import { Icon } from '../common';
import { startOfWeek, weekName, weeksBetween } from '../staff/week';
import { isoDate } from '../../lib/dates';

// Names the week the way a person says it out loud (daily-command-strip AC21).
// The header this replaced spent five elements on one idea — a label, a range,
// and a three-button segmented control. This is three, and the middle one is
// whichever of the two actually tells you something: the word for the weeks a
// person names, the dates for every week they do not. It was both at once, and
// "This week · 14–20 Aug" is one week stated twice.
export interface WeekHeaderProps {
  days: string[];
  onStep: (delta: number) => void;
}

export function WeekHeader({ days, onStep }: WeekHeaderProps) {
  // RELATIVE TO THE REAL WEEK, not to the page's anchor. `offset` is zero
  // whenever the panel opens, so viewing a date in March labelled March's week
  // "This week" and its neighbours "Last week" and "Next week" — confidently
  // wrong (PR #164, codex P2). The displayed week is compared against the week
  // containing today instead; the anchor still chooses which week opens first.
  // The comparison is direct date maths rather than a bounded walk outward: the
  // walk gave up after five years and fell through to "This week" (PR #164,
  // claude P3).
  const thisWeek = startOfWeek(isoDate(new Date()));
  const fromNow = weeksBetween(thisWeek, days[0] ?? thisWeek);

  return (
    <span className="cs-wk-nav">
      <button type="button" className="cs-wk-step" onClick={() => onStep(-1)} aria-label="Previous week">
        <Icon name="left" size={13} />
      </button>
      <span className={'cs-wk-rel' + (fromNow === 0 ? ' now' : '')}>{weekName(fromNow, days)}</span>
      <button type="button" className="cs-wk-step" onClick={() => onStep(1)} aria-label="Next week">
        <Icon name="right" size={13} />
      </button>
    </span>
  );
}
